var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnterpriseIconFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6765 0.16014C5.77171 0.0546538 0.136124 5.48909 0.00238614 12.3934C-0.0171956 13.4069 0.0841079 14.3937 0.292898 15.3401C0.646339 16.9425 0.856463 18.5732 0.856463 20.2143V23.3863C0.856463 23.8722 1.2504 24.2662 1.73643 24.2662H4.90842C6.5494 24.2662 8.18014 24.4764 9.78262 24.8298C10.729 25.0385 11.7157 25.1399 12.7293 25.1203C19.6334 24.9866 25.0679 19.3512 24.9626 12.4465C24.8598 5.70709 19.4158 0.26302 12.6765 0.16014Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15C8.10457 15 9 14.1046 9 13C9 11.8954 8.10457 11 7 11C5.89543 11 5 11.8954 5 13C5 14.1046 5.89543 15 7 15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 15C13.7608 15 14.6562 14.1046 14.6562 13C14.6562 11.8954 13.7608 11 12.6562 11C11.5517 11 10.6562 11.8954 10.6562 13C10.6562 14.1046 11.5517 15 12.6562 15Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3125 15C19.4171 15 20.3125 14.1046 20.3125 13C20.3125 11.8954 19.4171 11 18.3125 11C17.2079 11 16.3125 11.8954 16.3125 13C16.3125 14.1046 17.2079 15 18.3125 15Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseIconFilled);
export default __webpack_public_path__ + "static/media/enterprise-icon-filled.4cc321dd0f71b8213ab4ebaf380c2a16.svg";
export { ForwardRef as ReactComponent };